{
  "page": {
    "title": "Connect social chat",
    "loadFailed": "Unable to load channels",
    "lineConnected": "LINE OA connected",
    "nameUpdated": "Name updated",
    "activated": "Channel activated",
    "deactivated": "Channel deactivated",
    "statusCheckFailed": "Unable to check the channel status. Try again.",
    "toggleFailed": "Unable to change the channel status",
    "renameFailed": "Couldn't rename the channel",
    "invalidConnectUrl": "That connection URL isn't valid",
    "reconnectStartFailed": "Couldn't start reconnecting",
    "tokenExpiredTitle": "Channel token expired",
    "tokenExpiredContent": "Your {{platform}} needs to be reconnected. Continue?",
    "tokenExpiredOk": "Reconnect",
    "tokenExpiredCancel": "Later"
  },
  "section": {
    "addLine": "+ Add LINE OA",
    "addFacebook": "+ Add Facebook Page",
    "addInstagram": "+ Add Instagram",
    "emptyLine": "No LINE OA connected yet",
    "emptyFacebook": "No Facebook Page connected yet",
    "emptyInstagram": "No Instagram account connected yet"
  },
  "row": {
    "statusConnected": "Connected",
    "statusInactive": "Disabled",
    "statusReconnect": "Reconnection needed",
    "reconnectAria": "Reconnect this channel",
    "renameTooltip": "Click to rename",
    "renameAria": "Rename {{name}}",
    "saveNameAria": "Save name",
    "cancelAria": "Cancel",
    "avatarAlt": "Profile picture for {{name}}",
    "deactivateTitle": "Disable this channel?",
    "activateTitle": "Enable this channel?",
    "deactivateDescription": "Sight Order will stop receiving messages from this channel immediately",
    "activateDescription": "Sight Order will start receiving messages from this channel again",
    "deactivateOk": "Disable",
    "activateOk": "Enable",
    "confirmCancel": "Cancel",
    "deactivateAria": "Disable channel",
    "activateAria": "Enable channel"
  },
  "lineWarning": {
    "title": "Replies sent from LINE OA Manager aren't recorded",
    "body": "LINE doesn't send us a copy of replies made in the LINE OA Manager app or on manager.line.biz. To keep your chat history complete, always reply to LINE customers from Sight Order."
  },
  "facebook": {
    "title": "Connect a Facebook Page",
    "body": "You'll be taken to Facebook to authorise the connection. Your Facebook Page is then connected automatically.",
    "submit": "Connect Facebook",
    "failed": "Couldn't connect Facebook"
  },
  "instagram": {
    "title": "Connect Instagram",
    "body": "You'll be taken to Instagram to authorise the connection. Your Instagram account is then connected automatically.",
    "submit": "Connect Instagram",
    "failed": "Couldn't connect Instagram"
  },
  "tiktok": {
    "title": "Connect TikTok",
    "body": "You'll be taken to TikTok to authorise the connection, then brought back to this page.",
    "submit": "Connect TikTok",
    "failed": "Couldn't connect TikTok"
  },
  "line": {
    "title": "Connect LINE OA",
    "failed": "Couldn't connect LINE OA",
    "alreadyConnected": "This LINE OA is already connected",
    "copied": "Webhook URL copied",
    "copyFailed": "Couldn't copy — please copy it manually",
    "step1Title": "Step 1: Set the webhook in LINE OA Manager",
    "step1Open": "Open",
    "step1SelectAccount": "and choose your account",
    "step1Settings": "Click the",
    "step1SettingsBold": "Settings",
    "step1SettingsAfter": "icon in the top right",
    "step1MessagingBefore": "Go to the",
    "step1MessagingAfter": "menu in the left sidebar and enable Messaging API (if it isn't already)",
    "step1WebhookBefore": "In the",
    "step1WebhookAfter": "field, paste the URL below and save",
    "step2Title": "Step 2: Issue a Channel Access Token in the LINE Developers Console",
    "step2Open": "Open",
    "step2SelectProvider": "and choose the same Provider and Messaging API channel",
    "step2TabBefore": "Go to the",
    "step2TabMiddle": "tab, and under",
    "step2ToggleBefore": "turn on",
    "step2ToggleAfter": "(this matters — without it LINE won't deliver messages to us), and turn on",
    "step2RedeliveryAfter": "so LINE resends messages if we're briefly unavailable",
    "step2TokenBefore": "On the same page, scroll to",
    "step2TokenMiddle": "and press",
    "step2TokenAfter": "to create a token, then copy it into the form below",
    "step2SecretBefore": "Go to the",
    "step2SecretMiddle": "tab to copy your",
    "step2SecretAfter": "into the form below",
    "copy": "Copy",
    "copiedShort": "Copied",
    "webhookHint": "Paste this URL into the Webhook URL field in LINE Official Account Manager",
    "channelNameLabel": "Channel name",
    "channelNameRequired": "Please enter a channel name",
    "channelNamePlaceholder": "e.g. My shop",
    "tokenRequired": "Please enter the Channel Access Token",
    "tokenPlaceholder": "Paste the Channel Access Token here",
    "secretRequired": "Please enter the Channel Secret",
    "secretPlaceholder": "Paste the Channel Secret here",
    "cancel": "Cancel",
    "submit": "Connect"
  },
  "callback": {
    "successTikTok": "TikTok connected",
    "successFacebook_one": "Facebook Page connected",
    "successFacebook_other": "{{count}} Facebook Pages connected",
    "successInstagram_one": "Instagram account connected",
    "successInstagram_other": "{{count}} Instagram accounts connected",
    "returning": "Returning to settings...",
    "failedFacebook": "Couldn't connect the Facebook Page",
    "failedInstagram": "Couldn't connect Instagram",
    "failedTikTok": "Couldn't connect TikTok",
    "retry": "Try again",
    "goToChannels": "Go to channel settings",
    "pickerTitle": "Choose a Facebook Page to connect",
    "pickerSub": "One Page per shop. Choose the Page you want to receive messages on.",
    "pickerLoading": "Loading your Pages...",
    "pickerCancel": "Cancel",
    "pickerSubmit": "Connect this Page",
    "pickerSubmitting": "Connecting...",
    "pickerExpired": "This Page-selection link has expired. Please connect again.",
    "pickerNotOwned": "This link belongs to a different account. Please connect again.",
    "pickerLoadFailed": "We couldn't load your Pages. Please try again.",
    "selectExpired": "This link has expired. Please connect again.",
    "selectChannelLimit": "This shop already has a Facebook Page connected. Disconnect it first.",
    "selectFailed": "We couldn't connect the Page you selected",
    "fbAccessDenied": "You declined access, or no Page was selected. Try again and choose a Page.",
    "fbInvalidState": "This link has expired. Please try again.",
    "fbTokenExchangeFailed": "We couldn't complete the connection. Please try again.",
    "fbChannelLimit": "This shop already has a Facebook Page connected (one Page per shop). To switch Pages, disconnect the current one in channel settings and connect again.",
    "fbNoPages": "No connectable Page was found. Check that you're an admin of the Page and granted access to it.",
    "fbPickerLoadFailed": "We couldn't load your Pages. Please connect again.",
    "genericError": "Something went wrong. Please try again.",
    "igAccessDenied": "You declined access. Please try again.",
    "igInvalidState": "This link has expired. Please try again.",
    "igMissingCode": "The connection didn't complete. Please try again.",
    "igTokenExchangeFailed": "We couldn't connect to Instagram. Please try again.",
    "igNoAccounts": "No Instagram Business account linked to a Facebook Page was found. Check your account setup.",
    "igSelectOne": "Multiple accounts found. Please grant exactly one Page (linked to one Instagram account) and try again.",
    "igChannelLimit": "An Instagram account is already connected. Disconnect it before connecting a new one.",
    "igConnectFailed": "We couldn't connect that Instagram account. Please check the permissions.",
    "loginSuccess": "Signed in to Facebook",
    "loginSuccessAs": "Signed in to Facebook as {{name}}",
    "linkedChannelLimit": "This shop already has a Facebook Page connected (one Page per shop), so no new Page was attached. You can swap Pages below, or manage them in channel settings.",
    "linkedNoPages": "This Facebook account doesn't administer a Facebook Page we can connect. Create a Page, or ask a Page admin to give you access, then connect again.",
    "linkedOwnedElsewhere": "That Page is already connected to another shop. Disconnect it there first, then connect again.",
    "linkedGeneric": "No Page was attached this time. Please try again.",
    "replaceTitle": "Swap the connected Page",
    "replaceSub": "{{current}} is connected now. Choose the Page that should receive messages instead.",
    "replaceSubmit": "Replace the connected Page",
    "replaceConfirmTitle": "Replace {{current}}?",
    "replaceConfirmBody": "{{current}} will stop receiving messages in Sight Order and {{next}} will be connected instead. Existing conversations are kept.",
    "replaceConfirmOk": "Yes, replace it",
    "replaceCancel": "Keep the current Page",
    "replaceSubmitting": "Replacing...",
    "replaceFailed": "We couldn't replace the Page. Please try again.",
    "replaceAmbiguous": "This shop has several Facebook Pages connected, so there is no single Page to replace. Disconnect the one you want to swap in channel settings first.",
    "pageUnavailable": "Unavailable: Facebook doesn't let Sight Order receive this Page's messages.",
    "selectSubscribeFailed": "Facebook didn't let Sight Order receive that Page's messages, so it wasn't connected. Choose another Page, or check that you have full control of this one.",
    "linkedSubscribeFailed": "Facebook didn't let Sight Order receive this Page's messages, so it wasn't connected. Check that you have full control of the Page, then connect again.",
    "replaceSubscribeFailed": "Facebook didn't let Sight Order receive that Page's messages, so your current Page is still connected."
  }
}
